import { convertJsonToQueryString } from "../querystring";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reformatFormData = (data: Record<string, any>): Record<string, any> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formatData: any = {};

  Object.keys(data).map((key) => {
    if (data[key] !== "") {
      formatData[key] = data[key];
    }
  });

  return formatData;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addQueryParamsToUrl = (data: Record<string, any>, location: any, navigate: any, formData: boolean = true): void => {
  let queryParams = data;

  if (formData) {
    queryParams = reformatFormData(data);
  }

  const path = window.location.pathname;
  const currentState = location.state;
  const params = convertJsonToQueryString(queryParams);

  navigate(path + "?" + params, { state: currentState, replace: true });
};

export default addQueryParamsToUrl;
